import Slider from './slider';

export default class Timeline extends Slider {
  constructor (props) {
    props = Object.assign({
      max: props.player.getDuration(),
      value: props.player.getPosition(),
      progress: props.player.getBufferedPercentage(),
      name: 'Timeline seek'
    }, props);

    super(props);

    this.onadtimeupdate = this.onadtimeupdate.bind(this);
    this.onaddurationchange = this.onaddurationchange.bind(this);
    this.ontimeupdate = this.ontimeupdate.bind(this);
    this.ondurationchange = this.ondurationchange.bind(this);
    this.onprogress = this.onprogress.bind(this);
    this.onadstart = this.onadstart.bind(this);
    this.onadend = this.onadend.bind(this);
    this.onchange = this.onchange.bind(this);
  }

  getDefaultProps () {
    return Object.assign(super.getDefaultProps(), {
      position: 0,
      duration: 0,
      progress: 0
    });
  }

  setProps (newProps, update = true) {
    const mergedProps = Object.assign({}, this.props, newProps);

    mergedProps.max = mergedProps.duration;
    mergedProps.value = mergedProps.position;

    super.setProps(mergedProps, update);
  }

  onadtimeupdate (event) {
    this.setProps({ position: this.props.player.getAdPosition() });
  }

  onaddurationchange (event) {
    this.setProps({ duration: this.props.player.getAdDuration() });
  }

  ontimeupdate (event) {
    this.setProps({ position: this.props.player.getPosition() });
  }

  ondurationchange (event) {
    this.setProps({ duration: this.props.player.getDuration() });
  }

  onprogress (event) {
    this.setProps({ progress: this.props.player.getBufferedPercentage() });
  }

  onadstart (event) {
    this.setProps({
      progress: 0,
      position: this.props.player.getAdPosition(),
      duration: this.props.player.getAdDuration()
    });
  }

  onadend (event) {
    this.setProps({
      progress: this.props.player.getBufferedPercentage(),
      position: this.props.player.getPosition(),
      duration: this.props.player.getDuration()
    });
  }

  onchange () {
    this.props.player.setPosition(this.value);
  }

  updateBufferedProgress () {
    if (!this.$buffered) return;
    if (this.props.player.getState() === 'adplaying') {
      this.$buffered.style.width = '0%';
    } else {
      this.$buffered.style.width = `${this.props.progress}%`;
    }
  }

  update () {
    super.update();
    this.updateBufferedProgress();
  }

  render () {
    return `
      <div class="iono-timeline iono-slider">
        <div class="iono-slider-track"></div>
        <div class="iono-slider-progress iono-timeline-position-progress iono-theme-background-accent" style="width:0%;"></div>
        <div class="iono-timeline-buffered-progress iono-theme-background-accent" style="width:0%;"></div>
        <div class="iono-slider-container">
          <button class="iono-slider-knob" role="slider" aria-label="${this.props.name}" aria-valuemin="0" aria-valuemax="${this.props.duration}" aria-valuenow="${this.props.position}"></button>
        </div>
      </div>
    `;
  }

  attach (element) {
    super.attach(element);

    this.$buffered = this.$('.iono-timeline-buffered-progress');

    // update the props when we attach the timeline
    if (this.props.player.getState() === 'adplaying') {
      this.setProps({
        position: this.props.player.getAdPosition(),
        duration: this.props.player.getAdDuration()
      });
    } else {
      this.setProps({
        position: this.props.player.getPosition(),
        duration: this.props.player.getDuration()
      });
    }

    this.props.player.on('timeupdate', this.ontimeupdate);
    this.props.player.on('durationchange', this.ondurationchange);
    this.props.player.on('adtimeupdate', this.onadtimeupdate);
    this.props.player.on('addurationchange', this.onaddurationchange);
    this.props.player.on('progress', this.onprogress);
    this.props.player.on('adstart', this.onadstart);
    this.props.player.on('adend', this.onadend);
    this.on('change', this.onchange);
  }

  detach () {
    super.detach();

    this.$buffered = null;

    this.props.player.off('timeupdate', this.ontimeupdate);
    this.props.player.off('durationchange', this.ondurationchange);
    this.props.player.off('adtimeupdate', this.onadtimeupdate);
    this.props.player.off('addurationchange', this.onaddurationchange);
    this.props.player.off('progress', this.onprogress);
    this.props.player.off('adstart', this.onadstart);
    this.props.player.off('adend', this.onadend);
    this.off('change', this.onchange);
  }
}
